<!-- 积分设置 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="option" v-if="showTabs">
        <div class="left">
          <el-radio-group v-model="menus" @change="changeRadio">
            <el-radio-button label="消费送积分"></el-radio-button>
            <!-- <el-radio-button label="充值送积分"></el-radio-button> -->
            <el-radio-button label="积分抵扣设置"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="right">
        </div>
      </div>
      <div class="dflex">
        <div class="flexleft" v-loading="loading">
          <el-form label-width="140px">
            <el-form-item :label="opentitle">
              <el-radio-group v-model="form1.open">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="积分抵扣" v-if="type == 3">
              <div class="form_line">
                <div class="bdright" v-if="ruleTitle1">{{ruleTitle1}}</div>
                <div><el-input size="small" v-model="form1.rule.min" class="input_box"></el-input></div>
                <div class="bdright">{{ruleTitle2}}</div>
                <div><el-input size="small" v-model="form1.rule.amount" class="input_box"></el-input></div>
                <div class="bdright">{{ruleTitle3}}</div>
                <div><el-input size="small" v-model="form1.rule.rate" class="input_box"><i slot="suffix">%</i></el-input></div>
              </div>
            </el-form-item>
            <el-form-item :label="ruleLabel" v-else>
              <div class="form_line" v-for="(item,index) in form1.rule" :key="index">
                <div class="bdright" v-if="ruleTitle1">{{ruleTitle1}}</div>
                <div><el-input size="small" v-model="item.min" class="input_box"></el-input></div>
                <div class="bdright">{{ruleTitle2}}</div>
                <div><el-input size="small" v-model="item.max" class="input_box"></el-input></div>
                <div class="bdright">{{ruleTitle3}}</div>
                <div><el-input size="small" v-model="item.num" class="input_box"></el-input></div>
                <div class="bdright">{{ruleTitle4}}</div>
                <div><el-button icon="el-icon-close" type="danger" size="mini" @click="delRuleItem(1,index)"></el-button></div>
              </div>
              <div style="margin-top:10px;"><el-button icon="el-icon-plus" size="small" @click="addRuleItem(1)">增加优惠项</el-button></div>
            </el-form-item>
            <el-form-item label="适用场景">
              <el-checkbox-group v-model="checkList">
                <el-checkbox v-for="item in checkList_option" :key="item.payment_code" :label="item.payment_code">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveForm1">保存</el-button>
              <el-button type="" @click="getData()">撤销更改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPointSetting, setPointSetting, getPayWay } from "@/api/pointSetting";
import { mapGetters } from "vuex";
export default {
  props: {
    fromPage: {
      type: String,
      default: "newVip"
    }
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    
  },
  data() {
    return {
      menus: "消费送积分",
      form1: {
        open: 1,
        rule:[
          {
            min:"", //消费xx元
            max:"", //消费xx元
            num:"",  //送xx积分
          }
        ],
        scene: "", //适用场景
      }, //消费送积分
      form2: {}, //充值送积分
      form3: {}, //积分抵扣设置
      checkList:[], //适用场景
      checkList_option: [], //使用场景选项
      loading: false, //loading
      ruleTitle1: "消费", //规则列表text
      ruleTitle2: "元至",
      ruleTitle3: "元|每消费1元赠送",
      ruleTitle4: "积分",
      ruleLabel: "消费送积分",
      type: 1,
      opentitle: "开启消费送积分",
      showTabs: true, //显示tab标签页
    };
  },
  mounted() { 
    // this.init();
    this.type =1;
    this.menus = "消费送积分"
    if(this.fromPage == 'newVip'){
      // this.changeRadio(this.menus);
      console.log(this.type)
      // this.showTabs = false;
    }
    this.changeRadio(this.menus);
  },
  methods: {
    // 根据tab页获取数据
    getData(){ //type: 1.消费送积分;2.充值送积分;3.积分抵扣
      // this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        type: this.type
      }
      if(this.menus == '充值送积分'){
        data.type = 2;
      }
      if(this.menus == '积分抵扣设置'){
        data.type = 3;
      }
      getPointSetting(data).then(res=>{
        if(res.code == 200){
          this.form1 = {
            type: res.data.type,
            open: String(res.data.open),
            rule: res.data.rule,
            scene: res.data.scene
          };
          if(data.type == 3){
            if(this.form1.rule instanceof Array){
              this.form1.rule = {
                min: "",
                amount: "",
                rate: ""
              }
            }
          }
          this.checkList = res.data.scene.split(',');
        }else if(res.msg == '未设置'){
          this.form1 = {
            type: data.type,
            open: '1',
            rule:[
              {
                min:"",
                max:"",
                num:"", 
              }
            ],
            scene: ""
          }
          if(data.type == 3){
            this.form1.rule = {
              min: "",
              amount: "",
              rate: ""
            }
          }
          this.checkList = []
        }
        this.loading = false;
      })
      var data2 = {
        token: this.token,
        app_id: this.app_id,
        type: this.type == 2? 1:2
      }
      getPayWay(data2).then(res => {
        if(res.code == 200){
          this.checkList_option = res.data
        }else{
          this.$message(res.msg)
        }
      })
    },
    //切换tab页
    changeRadio(val) {
      if(val == '消费送积分'){
        this.type = 1
        this.ruleLabel = val
        this.ruleTitle1 = '消费'
        this.ruleTitle2 = '元至'
        this.ruleTitle3 = '元 | 每消费1元赠送'
        this.ruleTitle4 = '积分'
        this.opentitle = "开启消费送积分"
      }else if(val == '充值送积分'){
        this.type = 2
        this.ruleLabel = val
        this.ruleTitle1 = '充值'
        this.ruleTitle2 = '元至'
        this.ruleTitle3 = '元 | 每充值1元赠送'
        this.ruleTitle4 = '积分'
        this.opentitle = "开启充值送积分"
      }else if(val == '积分抵扣设置'){
        this.type = 3
        this.ruleLabel = '积分抵扣'
        this.ruleTitle1 = '最低消费'
        this.ruleTitle2 = '元 | 每积分可抵扣'
        this.ruleTitle3 = '元 | 最高抵扣订单金额'
        this.ruleTitle4 = ''
        this.opentitle = "开启积分抵扣"
      }
      this.getData();
    },
    //删除
    delItem(i){
      console.log(i)
    },
    saveForm1(){ //保存
      var data = Object.assign({},this.form1);
      data.token = this.token;
      data.app_id = this.app_id;
      var scenes = "";
      this.checkList.forEach(item=>{
        scenes += item + ','  
      })
      data.scene = scenes.substring(0,scenes.length-1);
      console.log(data)
      setPointSetting(data).then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: "保存成功"
          })
          this.getData();
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    addRuleItem(i){ //增加优惠项
      if(i == 1){
        this.form1.rule.push({min:'',max:'',num:''});
      }
    },
    delRuleItem(i,index){
      if(i == 1){
        if(this.form1.rule.length == 1){
          this.$message({
            type: "warning",
            message: "至少有一项优惠项"
          })
        }else{
          this.form1.rule.splice(index,1)
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 75px;
      line-height: 75px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span{
          margin-left: 30px;
          .el-select{
            width:150px;
          }
        }
      }
    }
    .dflex{
      display: flex;
      flex-wrap: wrap;
      flex:1;
      overflow: auto;
      .flexleft{
        flex:1;
        min-width: 500px;
        margin-top:10px;
      }
    }
    .form_line{
      // border:1px solid #eee;
      height: 40px;
      line-height: 40px;
      display: flex;
      width:auto;
      .bdright{
        padding: 0 10px;
        text-align: center;
      }
      .input_box{
        width:120px;
      }
    }
  }
}
</style>
